import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { colors } from 'styles/theme/colors';

type LoadingContentProps = {
    loading: boolean;
    children: React.ReactNode;
    text?: string;
};

export function LoadingContent({ loading, children, text }: LoadingContentProps) {
    return (
        <Box position="relative">
            <>
                {loading ? (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        zIndex: 10,
                    }}
                    >
                        <Box
                            sx={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                zIndex: 11,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 4,
                            }}
                        >
                            <CircularProgress sx={{ color: colors.secondary5 }} />
                            {text && <Typography variant="h2" fontStyle="italic">{text}</Typography>}
                        </Box>
                    </Box>
                ) : null}
                {children}
            </>
        </Box>
    );
}
